import { Card, Icon, Section } from '@ui/library';
import type { Outlet } from '@lib/schemas/publication';

export interface PublicationsCopy {
  eyebrow: string;
  title: string;
}

export interface PublicationsProps {
  outlets: ReadonlyArray<Outlet>;
  copy: PublicationsCopy;
}

export function Publications({ outlets, copy }: PublicationsProps) {
  return (
    <Section id="elsewhere" tight eyebrow={copy.eyebrow} title={copy.title}>
      <div className="homes" style={{ marginTop: 36 }}>
        {outlets.map((o) => (
          <Card key={o.name} variant="home" href={o.href}>
            <div>
              <b>{o.name}</b>
              <span>{o.note}</span>
            </div>
            <Icon name="arrow-up-right" size={18} />
          </Card>
        ))}
      </div>
    </Section>
  );
}
